import React,{useEffect} from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import MenuMarketplace from '../../../components/menus/MenuMarketplace'
import { FooterMarketplace } from '../../../components/footers/FooterMarketplace'

export default function SDPlay () {
    const { t } = useTranslation()
	useEffect(() =>{
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
    }, [])

    return (
		<>
            <MenuMarketplace/>
            <Container className='market'>
                <Row>
                    <Col className='mx-auto'>
                        <h1>{t('corporation.sdplay.title')}</h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h4 className='my-4'>{t('corporation.sdplay.paragraph1')}</h4>
                        <h4 className='my-4'>{t('corporation.sdplay.paragraph2')}</h4>
                        <h4 className='my-4'>{t('corporation.sdplay.paragraph3')}</h4>
                        <h4 className='my-4'>{t('corporation.sdplay.paragraph4')}</h4>
                    </Col>
                </Row>
            </Container>
            <FooterMarketplace className='m-0'/>
        </>
    )
}